import React, {useEffect, useState} from 'react';
import {FormattedMessage, useIntl} from 'react-intl';
import {RealTimeAccessComponent} from 'src/app/modules/Dashboard/components/RealTimeAccess';
import {ChartArea} from './components/ChartArea';
import {ChartBar} from './components/ChartBar';
import {GeneralIndicators} from './components/GeneralIndicators';
import {useDispatch, useSelector} from 'react-redux';
import * as dashActions from './_redux/dashboardActions';
import {AccessLastDay, callTypes, dashboardSlices} from './_redux/dashboardSlices';
import {DashboardModel, StateDashboard} from './_redux/dashboardSlices';
import {Col, Modal, Alert, CloseButton} from 'react-bootstrap';
// import {getRealTimeAccess} from 'src/services/dashboard.service';
import useWindowDimensions from './useWindowDimensions';
import './styles.css';
import {usePermisssion} from 'src/redux/userPermissions/usePermission';
import {USER_PERMISSIONS_PROPS} from 'src/redux/userPermissions/types';
import {format} from 'date-fns';
import {getRealTimeAccessLast} from '../../../services/dashboard.service';
// import { useScreenClass } from 'react-grid-system';

// function objectsAreSame(x: any[], y: any[]) {
//   var objectsAreSame = true;
//   for (var a of x) {
//     if (!y.some((f) => f.id == a.id)) {
//       objectsAreSame = false;
//       break;
//     }
//   }
//   return objectsAreSame;
// }
export function Dashboard() {
  const {actions} = dashboardSlices;
  const permissions = useSelector<any, USER_PERMISSIONS_PROPS>((stage) => stage.userPermissions);

  const [isReadOnlYView, setIsReadOnlYView] = useState(false);

  const [isShowModalNoAccess, setIsShowModalNoAccess] = useState(false);

  // alert(value);
  const [show, setShow] = useState<boolean>(sessionStorage.getItem('banner-modal') === 'false' ? false : true);
  const dispatch = useDispatch<any>();
  const {height, width} = useWindowDimensions();
  const [h, setH] = useState<number>(0);
  const {indicators, accessLastDay, accessLastWeek, realTimeAccess}: DashboardModel = useSelector(
    (state: StateDashboard): DashboardModel => ({
      indicators: state.dashboard.indicators,
      accessLastDay: state.dashboard.accessLastDay,
      accessLastWeek: state.dashboard.accessLastWeek,
      realTimeAccess: state.dashboard.realTimeAccess,
      isLoadingRealTimeAccess: state.dashboard.isLoadingRealTimeAccess
    })
  );

  const verifyAccessLastWeekApexData = (accessLastWeeks: any) => {
    const hasData = accessLastWeeks.some((accessLastWeek: any) => accessLastWeek.totalVisitants > 0 || accessLastWeek.totalPersons > 0);
    return hasData;
  };
  const verifyAccessLastDayApexData = (accessLastDays: any) => {
    const hasData = accessLastDays?.some((accessLastDay: any) => accessLastDay.qtAccess > 0);
    return hasData;
  };

  // const fakeIndicators = {
  //   totalPersonsActive: 6,
  //   totalVisitantsActive: 4,
  //   totalDevicesActive: 1,
  //   totalAccessAuthorized: 7,
  //   totalAccessUnauthorized: 0
  // };

  const fakeAccessLastDay:any[] = [
    // {
    //   hour: '9',
    //   qtAccess: 2
    // },
    // {
    //   hour: '10',
    //   qtAccess: 5
    // },
    // {
    //   hour: '11',
    //   qtAccess: 3
    // },
    // {
    //   hour: '12',
    //   qtAccess: 2
    // },
    // {
    //   hour: '13',
    //   qtAccess: 5
    // },
    // {
    //   hour: '14',
    //   qtAccess: 6
    // },
    // {
    //   hour: '15',
    //   qtAccess: 8
    // },
    // {
    //   hour: '16',
    //   qtAccess: 5
    // },
    // {
    //   hour: '17',
    //   qtAccess: 4
    // },
    // {
    //   hour: '18',
    //   qtAccess: 4
    // },
    // {
    //   hour: '19',
    //   qtAccess: 2
    // },
    // {
    //   hour: '20',
    //   qtAccess: 3
    // },
    // {
    //   hour: '21',
    //   qtAccess: 1
    // },
    // {
    //   hour: '22',
    //   qtAccess: 1
    // },
    // {
    //   hour: '23',
    //   qtAccess: 2
    // },
    // {
    //   hour: '0',
    //   qtAccess: 3
    // },
    // {
    //   hour: '1',
    //   qtAccess: 1
    // },
    // {
    //   hour: '2',
    //   qtAccess: 2
    // },
    // {
    //   hour: '3',
    //   qtAccess: 1
    // },
    // {
    //   hour: '4',
    //   qtAccess: 0
    // },
    // {
    //   hour: '5',
    //   qtAccess: 1
    // },
    // {
    //   hour: '6',
    //   qtAccess: 4
    // },
    // {
    //   hour: '7',
    //   qtAccess: 6
    // },
    // {
    //   hour: '8',
    //   qtAccess: 9
    // }
  ];

  const fakeAccessLastWeek:any[] = [
    // {
    //   day: '08/06/2022',
    //   totalVisitants: 3,
    //   totalPersons: 2
    // },
    // {
    //   day: '08/07/2022',
    //   totalVisitants: 6,
    //   totalPersons: 8
    // },
    // {
    //   day: '08/08/2022',
    //   totalVisitants: 1,
    //   totalPersons: 1
    // },
    // {
    //   day: '08/09/2022',
    //   totalVisitants: 6,
    //   totalPersons: 5
    // },
    // {
    //   day: '08/10/2022',
    //   totalVisitants: 3,
    //   totalPersons: 6
    // },
    // {
    //   day: '08/11/2022',
    //   totalVisitants: 4,
    //   totalPersons: 4
    // },
    // {
    //   day: '08/12/2022',
    //   totalVisitants: 9,
    //   totalPersons: 8
    // }
  ];

  const fakeRealTimeAccess = [
    {
      photo: 'https://cajamar.sp.gov.br/noticias/wp-content/uploads/sites/2/2021/07/site-vacinacao-33-anos.png',
      name: 'Emma Smith',
      dataHora: new Date(),
      destinationArea: 'Andar superior',
      status: 7
    },
    {
      photo: 'https://img.freepik.com/fotos-gratis/estilo-de-vida-beleza-e-moda-conceito-de-emocoes-de-pessoas-jovem-gerente-de-escritorio-feminino-asiatico-ceo-com-expressao-satisfeita-em-pe-sobre-um-fundo-branco-sorrindo-com-os-bracos-cruzados-sobre-o-peito_1258-59329.jpg?w=2000',
      name: 'Luciana Almeida',
      dataHora: 'Fri Aug 13 2022 15:14:32 GMT-0300 (Horário Padrão de Brasília)',
      destinationArea: 'Andar inferior',
      status: 7
    },
    {
      photo:
        'image/jpeg;base64,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',
      name: 'Lucas Carvalho',
      dataHora: 'Fri Aug 13 2022 20:44:22 GMT-0300 (Horário Padrão de Brasília)',
      destinationArea: 'Térreo',
      status: 7
    },
    {
      photo: 'https://images.unsplash.com/photo-1544168190-79c17527004f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=376&q=80',
      name: 'Yoko Taro',
      dataHora: 'Fri Aug 12 2022 14:11:06 GMT-0300 (Horário Padrão de Brasília)',
      destinationArea: 'Andar inferior',
      status: 1
    },
    {
      photo: 'https://images.unsplash.com/photo-1531384441138-2736e62e0919?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80',
      name: 'Marcelo Oliveira',
      dataHora: 'Fri Aug 11 2022 17:31:16 GMT-0300 (Horário Padrão de Brasília)',
      destinationArea: 'Andar superior',
      status: 1
    },
    {
      photo: 'https://images.unsplash.com/photo-1528892952291-009c663ce843?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=344&q=80',
      name: 'Pedro Lopes',
      dataHora: 'Fri Aug 11 2022 09:29:33 GMT-0300 (Horário Padrão de Brasília)',
      destinationArea: 'Andar inferior',
      status: 1
    },
    {
      photo: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80',
      name: 'Amanda Ribeiro',
      dataHora: 'Fri Aug 10 2022 11:38:02 GMT-0300 (Horário Padrão de Brasília)',
      destinationArea: 'Andar superior',
      status: 1
    }
  ];

  const [real, setReal] = useState<any[]>([]);
  const [realTime, setRealTime] = useState<any[]>([]);

  let lastId: { id: number | undefined; }; 
  let prevData: any; 
  // async function RealTime(LastLogId?: number) {

  //   try {
  //     const response =  await getRealTimeAccessLast({Quantity: 10, LastLogId});
      
  //     if (response?.data?.data?.length > 0) {
        
  //       // dispatch(actions.dashRealTimeAccessFetched(response?.data?.data));
  //       if (prevData) {
  //         // console.log('#### UNSHIFT', response?.data?.data.concat(prevData) )
  //         dispatch(actions.dashRealTimeAccessFetched(response?.data?.data.concat(prevData)));
  //       }

  //       lastId = response?.data?.data?.at(0)
  //       prevData = response?.data?.data;
  //     }
  //     // console.log("🚀  #### RealTime  lastId:", lastId)
  //     setTimeout(() => {
  //       RealTime(lastId?.id)
  //     }, 5000)
      
  //   }catch (err) {
  //     setTimeout(() => {
  //       // RealTime()
  //     }, 5000)
  //   }
  // }

  function getRealTimeAccessAll() {
    if (isReadOnlYView) return;
    // dispatch(actions.getRealTimeAccessAll());
    dispatch(dashActions.fetchRealTimeAccessFetched(real?.map((item: any) => item.id))).then(() =>  
      dispatch(dashActions.setLoadingRealTimeAccess(false))
    );
    // try {
    //   getRealTimeAccess().then((res) => {

    //     let tmp: any[] = res?.data?.data?.data || [];
    //     if (tmp?.length && !objectsAreSame(tmp, real)) {
    //       setRealTime(tmp);
    //     }
    //   });
    // } catch (error) {
    //   console.error(error);
    // }
  }
  const intl = useIntl();

  useEffect(() => {
    // RealTime()
    if (isReadOnlYView) return;

    let interval: any = null;
    dispatch(dashActions.fetchAccessLastDayFetched());
    dispatch(dashActions.fetchAccessLastWeekFetched());
    getRealTimeAccessAll();
    dispatch(dashActions.setLoadingRealTimeAccess(true))
    dispatch(dashActions.fetchDashIndicators());
    interval = setInterval(() => {
      // if (process.env.NODE_ENV == 'production')
      dispatch(dashActions.fetchRealTimeAccessFetched());
    }, 10000);
    setH(height);
    return () => {
      clearInterval(interval);
      localStorage.removeItem('@CONTROLID@_OPERATION_RULE_EDIT');
      // window.location.reload();
    };
  }, [isReadOnlYView]);

  // useEffect(() => {
  //   // let interval: any = null;
  //   // interval = setInterval(() => {
  //   //   getRealTimeAccessAll();
  //   // }, 1000);
  //   // return () => clearInterval(interval);
  // }, [real]);
  //   if (realTime?.length && !objectsAreSame(realTime, real)) {
  //     setReal(realTime);
  //   }
  // }, [realTime]);

  useEffect(() => {
    return () => {
      if (realTimeAccess && realTimeAccess.length) setReal(realTimeAccess);
    };
  }, [realTimeAccess]);

  useEffect(() => {
    const result = permissions.modules.find((m) => m.id === 1);

    if (result?.permission === 4) {
      setIsShowModalNoAccess(true);
      setIsReadOnlYView(true);
    }
    // setIsShowModalNoAccess(result);
  }, [permissions]);

  const numberFormat = (value: number) => {
    const local = intl.locale;
    const currency = local === 'es' ? 'INR' : local === 'pt' ? 'BRL' : 'USD';
    const form = intl.locale === 'es' ? 'en' : intl.locale;
    return new Intl.NumberFormat(form, {style: 'currency', currency}).format(value);
  };

  // IN PROGRESS

  // function MyVerticallyCenteredModal(props: any) {

  //   return (
  //     <Modal
  //       {...props}
  //       size="lg"
  //       aria-labelledby="contained-modal-title-vcenter"
  //       centered
  //     >
  //       <Modal.Header closeButton>
  //         <Modal.Title id="contained-modal-title-vcenter">
  //           Modal heading
  //         </Modal.Title>
  //       </Modal.Header>
  //       <Modal.Body>
  //         <h4>Centered Modal</h4>
  //         <p>
  //           Cras mattis consectetur purus sit amet fermentum. Cras justo odio,
  //           dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta
  //           ac consectetur ac, vestibulum at eros.
  //         </p>
  //       </Modal.Body>
  //       <Modal.Footer>
  //         <Button onClick={props.onHide}>Close</Button>
  //       </Modal.Footer>
  //     </Modal>
  //   );
  // }

  // console.log('fake',realTimeAccess, accessLastDay)

  const formatLogs = realTimeAccess?.map((item) => {
    return {
      id: item.id,
      dataHora: item.time,
      destinationArea: item.areaName === 'AREA.DEFAULT' ? intl.formatMessage({id: 'AREA.DEFAULT'}) : item.areaName,
      name: item.personName,
      photo: item.personAvatar,
      status: item.event,
      event: item.event
    };
  });

  const modalShow = !accessLastDay ? false : accessLastDay.length > 0 ? false : show;

  // console.log('data', intl.formatDate('2022-08-11T13:58:19'))

  return (
    <>
      <Modal
        // style={{width: '70vw'}}
        // show={modalShow}
        show={false}
        size={'lg'}
        onHide={() => {
          setShow(false);
          sessionStorage.setItem('banner-modal', 'false');
        }}
        // size="xl"
        // dialogClassName='modal-90w'
        // aria-labelledby='example-custom-modal-styling-title'
        centered>
        {/* <Modal.Body> */}
        <div>
          <button
            type='button'
            onClick={() => {
              setShow(false);
              sessionStorage.setItem('banner-modal', 'false');
            }}
            style={{
              color: '#888',
              border: 'none',
              backgroundColor: 'transparent',
              position: 'absolute',
              right: ' 0.15rem',
              top: '0.5rem'
            }}>
            <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 512' width='22' height='22'>
              <path
                fill='currentColor'
                d='M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z'
              />
            </svg>
          </button>
          <img src='/media/dashboard_banner.jpeg' style={{width: '100%', height: 'auto'}} />
        </div>
        {/* </Modal.Body> */}
      </Modal>

      {/* {show && (
        <div
          id='CTL_MODAL'
          onClick={() => {
            setShow(false);
            sessionStorage.setItem('banner-modal', 'false');
          }}>
          <div>
            <img src='/media/dashboard_banner.jpeg' />
            <button
              type='button'
              onClick={() => {
                setShow(false);
                sessionStorage.setItem('banner-modal', 'false');
              }}
              style={{
                color: '#888',
                border: 'none',
                backgroundColor: 'transparent',
                right: '93px',
                top: '5px',
                position: 'absolute',
                padding: '5px'
              }}>
              <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 512' width='22' height='22'>
                <path
                  fill='currentColor'
                  d='M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z'
                />
              </svg>
            </button>
          </div>
        </div>
      )} */}
      {/* {verifyAccessLastDayApexData(accessLastDay) || realTimeAccess!.length > 0 ? null : ( */}
      {modalShow && (
        <Alert key='light' variant='light'>
          {intl.formatMessage({id: 'DASH.DATA_FAKE_ALERT'})}
        </Alert>
      )}

      {isReadOnlYView && (
        <Alert key='light' variant='light'>
          {intl.formatMessage({id: 'AUTH.NOTVALIDATION.INVALID_LOGIN'})}
        </Alert>
      )}

      <div className='row  card-t-top'>
        <div className='col-sm-12 col-md-6 col-lg-6 col-xl-8 col-xxl-9'>
          <GeneralIndicators indicators={indicators} />

          <div className='row card-t-top'>
            <Col xl={6} sm={12} md={12}>
              <ChartArea heigth={h} accessLastDay={verifyAccessLastDayApexData(accessLastDay) || realTimeAccess!.length > 0 ? accessLastDay : fakeAccessLastDay} numberFormat={numberFormat} className='card-stretch card-stretch-half gutter-b ' symbolShape='circle' baseColor='primary' />
            </Col>
            <Col xl={6} sm={12} md={12}>
              <ChartBar
                readOnly={isReadOnlYView}
                heigth={h}
                accessLastWeek={verifyAccessLastWeekApexData(accessLastWeek) || realTimeAccess!.length > 0 ? accessLastWeek : []}
                // accessLastWeek={verifyAccessLastWeekApexData(accessLastWeek) || realTimeAccess!.length > 0 ? accessLastWeek : fakeAccessLastWeek}
                numberFormat={numberFormat}
                className='card-stretch card-stretch-half gutter-b'
                symbolShape='circle'
                baseColor='primary'
              />
            </Col>
          </div>
        </div>

        <div className='col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3'>
          <RealTimeAccessComponent realTimeAccess={formatLogs} className='card-stretch gutter-b' />
        </div>
      </div>
    </>
  );
}
